export enum CxIntegrationLicence {
    NONE = 'NONE',
    SOLO = 'SOLO',
    TEAMS = 'TEAMS',
    // Canonical CXI User wire value (renamed from the legacy 'CX INTEGRATION'); the backend still accepts the old value.
    CXI = 'CXI USER'
}

export enum CxiDataEntitlement {
    NONE = 'NONE',
    CXI_DATA = 'CXI DATA'
}

export type SelfProvisioningInitalDataFormState = {
    siteName: string
    siteIndustry: string
    enterpriseID: string
    userName: string
    password: string
}

export type SelfProvisioningUser = {
    userType: string
    email: string
    name?: string
    welcomeEmail: boolean
    useEmailAsUsername?: boolean
    // Legacy CXI User field kept for backward compatibility while callers migrate to explicit CXI User/CXI Data fields.
    cxiLicence?: string | CxIntegrationLicence
    // New additive CXI Data field for the split entitlement model.
    cxiDataEntitlement?: boolean
}

export type SelfProvisioningUserFormState = {
    users: SelfProvisioningUser[]
}

export type CustomerReferenceForm = {
    customerReference: string
}

export type BaseWebhookObject = {
    userInformation: {
        cmeName: string
    }
    companyInformation: {
        companyName: string
        companySector: string
    }
    companyConfig: {
        telSysID: number
        partitionID: number
        deviceCount: number
        users: {
            reportingSupervisors: number
            oneUsers: number
        }
    }
    otherInformation: {
        customerReference: string
        timestamp: string
    }
}

export type EntityCreateStatus = 'CREATED' | 'SYNCED' | 'WAITING' | 'FAILED'
